'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Healthcheck;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Healthcheck() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'p',
      null,
      'Healthcheck Success!'
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Healthcheck/Healthcheck.js
// module id = 869
// module chunks = 0